import React,{ useState,useEffect } from "react";
import {useParams} from 'react-router-dom';
import { OPTIONS_FOR_CAMPAIGN_LINK } from "../../constants/constants";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import MessagePreview from "./MessagePreview";
import { notifyError } from "../../helper";
import client from "../../api";

const CampaignMessagePreview = () => {
    const {campaignID} = useParams();
    const api = client();
    const [loading, setLoading] = useState(false);
    const [campaignPreview, setCampaignPreview]= useState({});
    const handleNextClick = () => {
        if(campaignID){
            setLoading(true);
            setTimeout(()=>{
                setLoading(false);
                window.location.href = OPTIONS_FOR_CAMPAIGN_LINK.replace(':campaignID',campaignID);    
            },1200);
            
        } else {
            notifyError('Campaign ID is missing');
        }        
    }
    useEffect(()=>{
    const getCampaignPreview = async () => {
        try{
            const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
            if(response.status === 200 ||response.status === 201 ){
                setCampaignPreview(response.data.campaignPreview);
            }
        } catch(error){
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
        } 
    }
   
    getCampaignPreview();    
},[]);
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-create-steps">
                <div className="top-section">
                    <h1>Add Campaign</h1>                
                </div>
                <div className="steps-wrap">
                    <Tabs currentTab={'preview'} completedTabs={campaignPreview.completed_tab} />
                    <div className="preview-step">
                        <h3 className="h3-title">Preview of each email</h3>
                        <div className="make-sure">Before hitting next, make sure:</div>
                        <ul className="sure-list">
                            <li><i className='bx bx-check-square'></i> you sound like a human</li>
                            <li><i className='bx bx-check-square'></i> your signature looks good</li>
                            <li><i className='bx bx-check-square'></i> your call to action is clear</li>
                            <li><i className='bx bx-check-square'></i> you have sent a test email and checked it on your phone</li>
                        </ul>
                        <button 
                            className={loading ? 'primary-btn button--loading':'primary-btn'}
                            disabled={loading} 
                            onClick={()=>handleNextClick()} ><span className="button--text">Next</span></button>
                        <MessagePreview campaignPreview={campaignPreview} />
                    </div>    
                </div>
            </div>            
        </div>
        <Footer/>
    </>);
}

export default CampaignMessagePreview;